import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/global.scss'
import '@/assets/styles/admin.scss'
import App from './App.vue'
import router from './router'
import i18n from '@/i18n'
import { bootstrapSiteSettings, initSiteSettings } from '@/store/siteSettings'
import { initAuth, auth } from '@/store/auth'
import { historyStore } from '@/store/history'
import { loadArticles, setArticlesLang } from '@/store/articles'
import { detectLocale } from '@/i18n/locale'

/**
 * 屏蔽浏览器扩展 / IDE 预览注入脚本的已知噪音报错
 *（如 reportAllChanges → reading 'startTime'），避免污染业务控制台。
 */
function isInjectedNoiseError(message, source) {
  const msg = String(message || '')
  const src = String(source || '')
  if (!msg.includes("reading 'startTime'") && !msg.includes('reportAllChanges')) {
    return false
  }
  // 扩展/注入脚本常见：匿名脚本、空文件名、或 chrome-extension 协议
  return !src
    || src === 'undefined'
    || src.includes('anonymous')
    || src.startsWith('chrome-extension://')
    || src.startsWith('moz-extension://')
}

window.addEventListener('error', (event) => {
  if (isInjectedNoiseError(event && event.message, event && event.filename)) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }
}, true)

window.addEventListener('unhandledrejection', (event) => {
  const reason = event && event.reason
  const msg = reason && (reason.message || String(reason))
  if (isInjectedNoiseError(msg, '')) {
    event.preventDefault()
    event.stopImmediatePropagation()
  }
}, true)

Vue.use(ElementUI, { zIndex: 4200 })

Vue.config.productionTip = false
Vue.config.errorHandler = (err, vm, info) => {
  if (err && isInjectedNoiseError(err.message, '')) return
  // 保留默认可见性：开发时仍打印真实业务错误
  if (typeof console !== 'undefined' && console.error) {
    console.error(`[Vue] ${info || 'error'}`, err)
  }
}

bootstrapSiteSettings()
setArticlesLang(detectLocale())

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

initSiteSettings()
initAuth().finally(() => {
  if (auth.isLoggedIn) {
    historyStore.fetchHistory()
  }
})
loadArticles()
